// seo-schema/hreflang-alternates.ts
//
// hreflang alternates for both platforms. Generalized from v5's version:
// takes siteUrl as a parameter instead of importing env (spec §1 rule 1 —
// zero framework/env imports in this module).

export const LOCALES = ["en", "my-mm"] as const;
export type Locale = (typeof LOCALES)[number];

/** `path` is locale-less with a leading slash, e.g. "/flight". */
export function buildLanguageAlternates(
  siteUrl: string,
  path: string,
): Record<string, string> {
  const site = siteUrl.replace(/\/$/, "");
  const langs = Object.fromEntries(LOCALES.map((l) => [l, `${site}/${l}${path}`]));
  return { ...langs, "x-default": `${site}/en${path}` };
}
